

// 獲取當前時間年月日
import store from "@/store";

export function getNowDate() {
  const date = new Date();
  const year = date.getFullYear(); // 年
  let month = date.getMonth() + 1; // 月
  let day = date.getDate(); // 日
  const weekArr = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];
  const week = weekArr[date.getDay()];
  if (month >= 1 && month <= 9) {
    month = "0" + month;
  }
  if (day >= 0 && day <= 9) {
    day = "0" + day;
  }
  return { week: week, dateString: year + " / " + month + " / " + day };
}

export function getCount() {
  const remain = new Date();
  let s = remain.getSeconds();
  let m = remain.getMinutes();
  let h = remain.getHours();
  let time = s + m * 60 + h * 3600;
  let timeInterval = "";
  if (time > 12 * 3600) {
    timeInterval = "下午";
  } else {
    timeInterval = "上午";
  }
  s = s < 10 ? "0" + s : s;
  h = h < 10 ? "0" + h : h;
  m = m < 10 ? "0" + m : m;

  return { time: h + " : " + m, timeInterval };
}

export function printDate(oldDate) {
  const d = oldDate ? new Date(oldDate) : new Date();
  const year = d.getFullYear();
  const month = d.getMonth() > 8 ? d.getMonth() + 1 : "0" + (d.getMonth() + 1);
  const date = d.getDate() > 9 ? d.getDate() : "0" + d.getDate();
  return `${year}-${month}-${date}`;
}


export function getWeekday(date) {
  const weekdays = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];
  const weekday = new Date(date).getDay();
  return weekdays[weekday];
}

export function rTime(time) {
  if (time === "") { // 解決deteForm為空傳1970-01-01 00:00:00
    return "";
  } else if (time === undefined) {
    return "";
  } else {
    return new Date(+new Date(new Date(time).toJSON()) + 8 * 3600 * 1000)
      .toISOString()
      .replace(/T/g, " ")
      .replace(/\.[\d]{3}Z/, "");
  }
}

export const itemDate = [
  { id: 1, name: "月子膳食" },
  { id: 2, name: "養胎膳食" },
  { id: 3, name: "小產膳食" },
  { id: 4, name: "術後膳食" },
  { id: 5, name: "調理膳食" }
];

export const stage = [
  { id: 1, name: "早" },
  { id: 2, name: "午" },
  { id: 3, name: "晚" }
];


// 根據年月獲取日曆上展示的日期
export function getRangeDate(year, month, olddate) {
  const firstDayOfMonth = month - 1 == 0 ? new Date(year - 1, 12, 1) : new Date(year, month - 1, 1)
  const lastDayOfMonth = new Date(year, month, 0)
  const daysInMonth = lastDayOfMonth.getDate()
  const oldyear = new Date().getFullYear()
  const oldmonth = new Date().getMonth() + 1
  const oldday = new Date().getDate()
  const calendarData = []

  // 填充上个月的末尾几天
  const prevMonthLastDay = new Date(year, month - 1, 0).getDate()
  for (let i = firstDayOfMonth.getDay(); i > 0; i--) {
    calendarData.push({
      day: prevMonthLastDay - i + 1,
      month: Number(month) - 1,
      year: year,
      isCurrentMonth: false
    })
  }

  // 填充当前月份的所有天数
  if (year > oldyear) {
    for (let i = 1; i <= daysInMonth; i++) {
      const curDate = new Date(year + '-' + month + '-' + i)
      calendarData.push({
        day: i,
        month: month,
        year: year,
        week: curDate.getDay(),
        isCurrentMonth: true
      })
    }
  } else if (year == oldyear) {
    if (month > oldmonth) {
      for (let i = 1; i <= daysInMonth; i++) {
        const curDate = new Date(year + '-' + month + '-' + i)
        calendarData.push({
          day: i,
          month: month,
          year: year,
          week: curDate.getDay(),
          isCurrentMonth: true
        })
      }
    } else if (month == oldmonth) {
      for (let i = 1; i <= daysInMonth; i++) {
        const curDate = new Date(year + '-' + month + '-' + i)
        if (i >= oldday) {
          calendarData.push({
            day: i,
            month: month,
            year: year,
            week: curDate.getDay(),
            isCurrentMonth: !!olddate.find(it => it.year == year && it.month == month && it.day == i)
          })
        } else {
          calendarData.push({
            day: i,
            month: month,
            year: year,
            week: curDate.getDay(),
            isCurrentMonth: false
          })
        }
      }
    } else {
      for (let i = 1; i <= daysInMonth; i++) {
        const curDate = new Date(year + '-' + month + '-' + i)
        calendarData.push({
          day: i,
          month: month,
          year: year,
          week: curDate.getDay(),
          isCurrentMonth: true
        })
      }
    }
  } else {
    for (let i = 1; i <= daysInMonth; i++) {
      const curDate = new Date(year + '-' + month + '-' + i)
      calendarData.push({
        day: i,
        month: month,
        year: year,
        week: curDate.getDay(),
        isCurrentMonth: true
      })
    }
  }

  // 填充下个月的开始几天
  const nextMonthFirstDay = new Date(year, month, 1).getDay()
  for (let i = 1; i <= 7 - nextMonthFirstDay; i++) {
    calendarData.push({
      day: i,
      month: Number(month) + 1,
      year: year,
      isCurrentMonth: false
    })
  }

  return calendarData
}

// 獲取所有年月日
export function getAllDate(start, end, startcan, endcan) {
  const dateList = []
  const startTime = Date.parse(new Date(start))
  const endTime = Date.parse(new Date(end))
  const days = Math.ceil((endTime - startTime) / (1000 * 60 * 60 * 24))
  for (let i = 0; i < days + 1; i++) {
    const tempDate = new Date(startTime + i * 24 * 60 * 60 * 1000)
    const newYear = tempDate.toLocaleDateString().slice(0, tempDate.toLocaleDateString().indexOf('/'))
    const newMonth = tempDate.toLocaleDateString().slice(tempDate.toLocaleDateString().indexOf('/') + 1, tempDate.toLocaleDateString().lastIndexOf('/')) < 10 ? '0' + tempDate.toLocaleDateString().slice(tempDate.toLocaleDateString().indexOf('/') + 1, tempDate.toLocaleDateString().lastIndexOf('/')) : tempDate.toLocaleDateString().slice(tempDate.toLocaleDateString().indexOf('/') + 1, tempDate.toLocaleDateString().lastIndexOf('/'))
    const newDay = tempDate.toLocaleDateString().slice(tempDate.toLocaleDateString().lastIndexOf('/') + 1) < 10 ? '0' + tempDate.toLocaleDateString().slice(tempDate.toLocaleDateString().lastIndexOf('/') + 1) : tempDate.toLocaleDateString().slice(tempDate.toLocaleDateString().lastIndexOf('/') + 1)
    const obj = {
      year: newYear,
      month: newMonth,
      day: newDay,
      date: newYear + '-' + newMonth + '-' + newDay,
      breakfast: i == 0 && startcan > 1 ? 3 : 1,
      lunch: i == 0 && startcan > 2 ? 3 : i == days && endcan < 2 ? 3 : 1,
      dinner: i == days && endcan < 3 ? 3 : 1,
      week: new Date(tempDate.toLocaleDateString()).getDay(),
      zhou: new Date(tempDate.toLocaleDateString()).getDay() == 0
        ? getMonthWeek(tempDate.toLocaleDateString()) + 1
        : getMonthWeek(tempDate.toLocaleDateString())
    }
    dateList.push(obj)
  }
  console.log('wwww', dateList)
  return dateList
}

// 根據日期判斷第幾周
function getMonthWeek(date) {
  const time = new Date(date)
  let w = time.getDay()
  const d = time.getDate()
  if (w == 0) {
    w = 7
  }
  return Math.ceil((d + 6 - w) / 7)
}

// 判斷權限

export function isPermission(value){
  const accessedRoutes = store.state.user.accessedRoutes
  if (value && typeof (value) === 'string') {
   if(hasPermissionHandle(accessedRoutes).includes(value)){
     return true
   }else{
     return false
   }
  }else{
    return false
  }
}

const hasPermissionHandle = function(accessedRoutes) {
  let list = []
  const hasPermission = function(accessedRoutes) {
    for(let i = 0;i < accessedRoutes.length;i++){
      list.push(accessedRoutes[i].name)
      if (accessedRoutes[i].children && accessedRoutes[i].children.length > 0) {
        hasPermission(accessedRoutes[i].children)
      }
    }
  }
  hasPermission(accessedRoutes)
  return list
}
